export { Collection as default } from './Collection';
